<template>
  <div>
    <div class="field">
      <label class="label">Rok służbowy:</label>
      <div class="control">
        <input
          type="text"
          class="input is-medium has-text-weight-semibold"
          v-model="serviceYear"
          >
      </div>
    </div>

    <div
      class="a4"
      v-for="(group, index) in grouped"
      :key="`group-${index}`"
      >
      <div class="a4__year">{{ serviceYear }}</div>
      <div class="header a4__cols">
        <div
          v-for="(id, idx) in group"
          :key="id"
          class="a4__col"
          :class="`is-${idx}`"
          v-html="id"
          >
        </div>
      </div>

      <div class="entries" v-show="false">
        <div class="line a4__cols">
          <div class="a4__col is-1">
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Piotr Hewakowski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Piotr Hewakowski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Piotr Hewakowski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
          </div>
          <div class="a4__col is-2">
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
          </div>
          <div class="a4__col is-3">
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
          </div>
          <div class="a4__col is-4">
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Piotr Hewakowski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
          </div>
          <div class="a4__col is-5">
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Piotr Hewakowski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Kamil Mendelski</div>
              <div class="dates">
                <span>12.01.2020</span>
                <span>28.03.2020</span>
              </div>
            </div>
            <div class="slot">
              <div class="person">Elżbieta Pszczółkowska</div>
              <div class="dates">
                <span>29.11.2019</span>
                <span>11.01.2020</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getSortedListByKeys } from '../utils';

export default {
  data: () => ({
    serviceYear: (new Date()).getFullYear(),
  }),
  computed: {
    ...mapState([
      'list',
      'settings',
    ]),
    grouped() {
      const sorted = getSortedListByKeys(this.list, Object.keys(this.list));
      const onlyIds = Object.values(sorted).map(({ id }) => (id));
      const groups = this.groupBy(onlyIds, 20);

      return groups;
    },
  },
  methods: {
    groupBy(arr = [], n = 0) {
      if (!arr.length) {
        return [];
      }

      return [arr.slice(0, n)].concat(this.groupBy(arr.slice(n), n));
    },
  },
};
</script>

<style lang="scss" scoped>
.field {
  @media print {
    display: none !important
  }

  .input {
    max-width: 100%;
    width: 210mm;
  }
}

.a4 {
  width: 210mm;
  height: 297mm;
  background-image: url(/S-13_P.png);
  background-repeat: no-repeat;
  // background-position: -4mm -2mm;
  background-size: 210mm auto;
  position: relative;
  overflow: hidden;
  page-break-before: always;
  // margin-left: 3mm;
  // margin-top: 2mm;

  @media screen {
    outline: 1px dashed #ddd;
  }
}

.a4__cols {
  position: absolute;
  top: 52mm;
  left: 12mm;
  width: 11mm;
}

.a4__col {
  text-align: center;
  font-weight: 800;
  color: #000;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  height: 11mm;
  white-space: pre;

  display: flex;
  align-items: center;
  justify-content: center;
}

.a4__year {
  position: absolute;
  top: 27.5mm;
  left: 42mm;
  width: 20mm;
  font-weight: 800;
  font-size: 18px;
  text-align: center;
}

@media print {
  html,
  body,
  .a4 {
    -webkit-print-color-adjust: exact;
  }
}

.entries {
  position: absolute;
  top: 29.25mm;
  left: 11.5px;
  width: calc(210mm - 11.5px - 20.5px);
}

.slot + .slot {
  margin-top: 4.85px;
}

.person,
.dates {
  display: block;
}

.person {
  height: 14.75px;
  margin-bottom: 3px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: .02em;
}

.dates {
  height: 15.5px;
  font-size: 10px;
  padding-top: 1px;
  display: flex;
  align-items: center;
  font-family: 'Roboto Mono', monospace;
}

.person,
.dates > span {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.dates > span {
  flex: 0 0 50%;
}

.line .a4__col {
  text-align: center;
}
</style>
